var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginChoosyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M5 13a4 4 0 1 0 0 8h9.529A5.978 5.978 0 0 1 13 17c0-1.537.578-2.938 1.528-4H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8DDAF2",
  d: "M5 15a2 2 0 1 0 0 4h8.342A5.99 5.99 0 0 1 13 17c0-.701.12-1.374.341-2H5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M19 13a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8DDAF2",
  d: "M19 15a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M19 3a4 4 0 1 1 0 8H9.471A5.978 5.978 0 0 0 11 7a5.978 5.978 0 0 0-1.528-4H19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M19 5a2 2 0 1 1 0 4h-8.342A5.99 5.99 0 0 0 11 7a5.99 5.99 0 0 0-.341-2H19z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M5 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M5 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
}))));
export default SvgPluginChoosyIcon;